import { useMemo, createContext } from 'react';
import { ColumnContainer, GridContainer } from './styled.js';
import { jsx } from 'react/jsx-runtime';

var GridContext = /*#__PURE__*/createContext({});
/* Column */
function Column(props) {
  var _children = props.children,
    _props$width = props.width,
    width = _props$width === void 0 ? '100%' : _props$width,
    className = props.className;
  return /*#__PURE__*/jsx(GridContext.Consumer, {
    children: function children(_ref) {
      var spacing = _ref.spacing,
        horizontal = _ref.horizontal,
        vertical = _ref.vertical;
      return /*#__PURE__*/jsx(ColumnContainer, {
        className: className,
        $spacing: spacing,
        $horizontal: horizontal,
        $vertical: vertical,
        style: {
          width: width
        },
        children: _children
      });
    }
  });
}
/* Grid */
function Grid(props) {
  var children = props.children,
    _props$spacing = props.spacing,
    spacing = _props$spacing === void 0 ? 6 : _props$spacing,
    _props$directions = props.directions,
    directions = _props$directions === void 0 ? 'horizontal vertical' : _props$directions,
    className = props.className;
  var _useMemo = useMemo(function () {
      var parts = directions.split(' ');
      return [parts.includes('horizontal'), parts.includes('vertical')];
    }, [directions]),
    horizontal = _useMemo[0],
    vertical = _useMemo[1];
  return /*#__PURE__*/jsx(GridContainer, {
    $spacing: spacing,
    $horizontal: horizontal,
    $vertical: vertical,
    className: className,
    children: /*#__PURE__*/jsx(GridContext.Provider, {
      value: {
        spacing: spacing,
        horizontal: horizontal,
        vertical: vertical
      },
      children: children
    })
  });
}

export { Column, Grid };
